import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'
import VCalendar from 'v-calendar';
import axios from 'axios'
import VueInputMask from './helpers/vue-inputmask.js';

import '@/init.sass';

//Vue.config.productionTip = false
window.app = createApp(App)
    .use(store)
    .use(router)
    .use(VCalendar)
    .use(VueInputMask)
    .mount('#app');
